<template>
  <b-form>
    <!-- DATOS DE CONTACTO -->
    <b-row class="mt-2">
      <!-- NOMBRE -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="nombre"
            rules="required|min:3|alpha_spaces"
          >
            <b-form-input
              v-model="formulario.nombre"
              :state="errors.length > 0 ? false:null"
              placeholder="Nombre"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- SEGUNDO NOMBRE -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="segundo nombre"
            rules="min:3|alpha_spaces"
          >
            <b-form-input
              v-model="formulario.segundoNombre"
              :state="errors.length > 0 ? false:null"
              placeholder="Segundo nombre"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- APELLIDO PATERNO -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="apellido paterno"
            rules="required|min:2|alpha_spaces"
          >
            <b-form-input
              v-model="formulario.apellidoPaterno"
              :state="errors.length > 0 ? false:null"
              placeholder="Apellido paterno"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- APELLIDO MATERNO -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="apellido materno"
            rules="min:2|alpha_spaces"
          >
            <b-form-input
              v-model="formulario.apellidoMaterno"
              :state="errors.length > 0 ? false:null"
              placeholder="Apellido materno"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- CORREO ELECTRÓNICO PERSONAL -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="correo"
            rules="required|email"
          >
            <b-form-input
              v-model="formulario.email"
              :state="errors.length > 0 ? false:null"
              placeholder="Correo electrónico personal"
              disabled
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- CORREO ELECTRÓNICO DE TRABAJO -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="correo de trabajo"
            rules="email"
          >
            <b-form-input
              v-model="formulario.emailAlt"
              :state="errors.length > 0 ? false:null"
              placeholder="Correo electrónico laboral (opcional)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- TELÉFONO PERSONAL -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="teléfono"
            rules="required|digits:10"
          >
            <cleave
              v-model="formulario.telefono1"
              class="form-control"
              :class="{ 'is-invalid' : (errors.length > 0 ? false:null) == false }"
              :raw="true"
              :options="cleaveOptions.phone"
              :state="errors.length > 0 ? false:null"
              placeholder="Teléfono personal"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- TELÉFONO DE TRABAJO -->
      <b-col md="4">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="teléfono"
            rules="digits:10"
          >
            <cleave
              v-model="formulario.telefono2"
              class="form-control"
              :class="{ 'is-invalid' : (errors.length > 0 ? false:null) == false }"
              :raw="true"
              :options="cleaveOptions.phone"
              :state="errors.length > 0 ? false:null"
              placeholder="Teléfono laboral (opcional)"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- EXTENSION -->
      <b-col md="2">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="extensión"
            rules="integer"
          >
            <b-form-input
              v-model="formulario.extension"
              :state="errors.length > 0 ? false:null"
              placeholder="Extensión"
              :disabled="!formulario.telefono2"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- CURP -->
      <b-col md="6">
        <b-form-group>
          <b-form-input
            v-model="formulario.curp"
            placeholder="CURP"
            disabled
          />
        </b-form-group>
      </b-col>

      <!-- FECHA DE NACIMIENTO -->
      <b-col>
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="fecha de nacimiento"
            rules="required"
          >
            <cleave
              id="fecha-de-nacimiento"
              v-model="formulario.fechaNacimiento"
              :options="cleaveOptions.date"
              :raw="false"
              class="form-control"
              placeholder="Fecha de nacimiento (YYYY-MM-DD)"
              :class="{ 'is-invalid' : (errors.length > 0 ? false:null) == false }"
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>
    </b-row>

    <!-- direccion -->
    <b-row>
      <b-col md="12">
        <formularioDireccion
          ref="refDireccion"
          :rulerequerido="true"
        />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  required, email, confirmed, password,
} from '@validations'
import Cleave from 'vue-cleave-component'
import formularioDireccion from '@/views/components/datosDireccion.vue'
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import { ref, watch } from '@vue/composition-api'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    formularioDireccion,
    Cleave,
    ValidationProvider,
  },
  props: {
    persona: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  setup(props) {
    const toast = useToast()
    const formulario = ref({})
    const direccion = ref({})
    const refDireccion = ref(null)
    const cleaveOptions = {
      phone: {
        phone: true,
        phoneRegionCode: 'US',
      },
      date: {
        date: true,
        delimiter: '-',
        datePattern: ['Y', 'm', 'd'],
      },
    }

    // Get birthdate from curp
    const getBirthDateFromCurp = ({ curp }) => {
      try {
        if (curp === null) return

        const date = curp.slice(4, 10)

        if (Number.isNaN(parseInt(date, 10)) || date.length !== 6) return

        const year = date.slice(0, 2)
        const month = date.slice(2, 4)
        const day = date.slice(4)

        const fullYear = parseInt(year[0], 10) > 5 ? `19${year}` : `20${year}`

        formulario.value.fechaNacimiento = `${fullYear}-${month}-${day}`
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Catálogo de entidades federativas',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    watch(() => props.persona, value => {
      formulario.value = value
      direccion.value = refDireccion.value.formulario

      if (value.curp === '') return

      getBirthDateFromCurp({ curp: value.curp })
    })

    return {
      required,
      password,
      email,
      confirmed,
      cleaveOptions,

      formulario,
      direccion,

      refDireccion,
    }
  },
}
</script>
